export const NAME_MAX_LENGTH = 255;
export const EMAIL_MAX_LENGTH = 255;
export const DETAILS_MAX_LENGTH = 500;
